import { render } from "./FolderModal.vue?vue&type=template&id=1535058c&scoped=true"
import script from "./FolderModal.vue?vue&type=script&lang=js"
export * from "./FolderModal.vue?vue&type=script&lang=js"

import "./FolderModal.vue?vue&type=style&index=0&id=1535058c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1535058c"]])

export default __exports__